import { isAfter, parseISO } from 'date-fns';
import { STATUS, type Project } from './project';

// 案件の募集の進み具合に関する判定。案件カード（projects/cardStatus.tsx・cardPercentage.tsx）と
// エンジェル税制シミュレーターの案件カードで同じ判定を使う

// 事前開示中か（申込開始前、または商品が未登録）。不成立の案件は含めない
export function isPreOpen(project: Project, now: Date = new Date()): boolean {
  return (
    project.status !== STATUS.failed &&
    (isAfter(parseISO(project.startAt), now) || project.productsSize === 0)
  );
}

// 申込開始済みか（申込開始後で商品あり）。不成立の案件は含めない
export function isOpened(project: Project, now: Date = new Date()): boolean {
  return (
    project.status !== STATUS.failed &&
    isAfter(now, parseISO(project.startAt)) &&
    project.productsSize > 0
  );
}

// 目標達成率（%、切り捨て）。受渡金額が無い（null・0）なら応募金額で計算する
export function achievementRate(project: Project): number {
  const price =
    project.delivPrice != null && project.delivPrice !== 0
      ? project.delivPrice
      : project.solicited;
  return Math.floor((price * 100) / project.solicit);
}
